import { getApiOrigin } from '@hungryroot/rest';
import { onSignupSuccess } from '../on-signup-success';
import { waitAndReload } from '../redirects';

type HungryRootAppleSignInResp = AppleSignInAPI.SignInResponseI & {
  authorization: AppleSignInAPI.SignInResponseI['authorization'] & {
    is_web?: boolean;
    user?: AppleSignInAPI.SignInResponseI['user'];
  };
};

interface Params {
  redirectUrl?: string;
  init: {
    clientId: string;
    scope: string;
    redirectURI: string;
    state: string;
  };
  $login: JQuery<HTMLElement>;
}

export function init(params: Params) {
  const { $login, init, redirectUrl } = params;
  window.AppleID.auth.init({
    ...init,
    usePopup: true, // shows a pop up instead of page redirect, so we can perform additinal logging/checking
  });

  $('.appleid-signin-button').on('click', (evt) => {
    evt.preventDefault();

    AppleID.auth
      .signIn()
      // No need to keep these lines below since Apple would redirect
      .then((data: HungryRootAppleSignInResp) => {
        data.authorization.is_web = true;
        if (data.user) {
          data.authorization.user = data.user;
        }

        $.ajax({
          type: 'POST',
          url: `${getApiOrigin()}/api/apple_login`,
          data: data.authorization,
          success: (resp) => {
            if (dataLayer && typeof dataLayer.push == 'function') {
              const ga_track_data: {
                event?: string;
                signup?: {
                  method: string;
                };
                login?: {
                  method: string;
                };
                customer: {
                  id: string;
                  email: string;
                };
              } = {
                customer: {
                  id: resp.customer.id,
                  email: resp.customer.email,
                },
              };
              const method = { method: 'apple' };

              if (resp.created) {
                ga_track_data.event = 'hr.signup.success';
                ga_track_data.signup = method;
                dataLayer.push(ga_track_data);
                onSignupSuccess(
                  resp.customer.id,
                  redirectUrl,
                  resp.customer,
                  'apple'
                );
              } else {
                ga_track_data.event = 'hr.login.success';
                ga_track_data.login = method;
                dataLayer.push(ga_track_data);
                waitAndReload();
              }
            }
          },
          error: () => {
            $login.find('.login-error').show();
            $login.find('.dialog').effect('shake', { times: 3, displace: 10 });

            // TODO: no way to determine if it was login or signup if this fails
            //       just use 'login' for now
            typeof ga === 'function' && ga('send', 'event', 'login', 'failure');
          },
        }).catch(() => {
          typeof ga === 'function' && ga('send', 'event', 'login', 'failure');
        });
      });
  });
}
